import { Calendar as KCalendar } from '@ui-kitten/components';
export default {
    Kitten: KCalendar,
};
//# sourceMappingURL=Calendar.js.map